import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { AUTOCALLER_URL } from '@shared/helpers/env';
class StatsServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }
  getListExtend(params) {
    return this.http.get('/', { params });
  }

  export(params) {
    return this.http.post('/export', params);
  }
  
  download(path) {
    return this.full_response_http.get(path);
  }
}

export const StatsService = new StatsServiceClass({
  api_version: 1,
  base_url: AUTOCALLER_URL,
  resource: 'stats'
});
